var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 15.8152 23.683 18.9946 21.3388 21.3388C18.9946 23.683 15.8152 25 12.5 25C9.18479 25 6.00537 23.683 3.66117 21.3388C1.31696 18.9946 0 15.8152 0 12.5C0 9.18479 1.31696 6.00537 3.66117 3.66117C6.00537 1.31696 9.18479 0 12.5 0C15.8152 0 18.9946 1.31696 21.3388 3.66117C23.683 6.00537 25 9.18479 25 12.5ZM12.5 5.46875C12.5 5.26155 12.4177 5.06284 12.2712 4.91632C12.1247 4.76981 11.926 4.6875 11.7188 4.6875C11.5115 4.6875 11.3128 4.76981 11.1663 4.91632C11.0198 5.06284 10.9375 5.26155 10.9375 5.46875V14.0625C10.9375 14.2002 10.974 14.3355 11.0431 14.4545C11.1123 14.5736 11.2117 14.6723 11.3312 14.7406L16.8 17.8656C16.9795 17.9626 17.1898 17.9856 17.3859 17.9296C17.5821 17.8736 17.7486 17.7431 17.8498 17.5659C17.951 17.3888 17.9789 17.1791 17.9275 16.9817C17.8762 16.7843 17.7497 16.6147 17.575 16.5094L12.5 13.6094V5.46875Z",
    fill: "#AB0505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitIcon);
export default __webpack_public_path__ + "static/media/wait_icon.bc41c68d4e4803efa54a67ea0228e950.svg";
export { ForwardRef as ReactComponent };